// /* eslint-disable no-constant-binary-expression */
// /* eslint-disable react-refresh/only-export-components */
// import { useFormik } from 'formik';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import Select from 'react-select';
// import { Card, CardFooter } from '@components/card/card';
// import { CardBody, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useNavigate, useParams } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import { TreeSelect } from 'antd';
// import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import { updateApPayments, getApPaymentsById, cancelApPayments } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
// import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
// import useGetPaymentTypeList from '@hooks/Finance/ApPayments/useGetPaymentTypeList';
// import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
// import { useEffect, useState } from 'react';
// import ApScheduleList from '../ApScheduleList';
// import NeatixModal from '@components/Modal/NeatixModal';
// import JournalsByReference from '../../../Journals/JournalsByReference/JournalsByReference';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import { paymentTypeEnum } from '../paymentTypeEnum';
// import PaymentDetailsCard from '../Add/PaymentDetailsCard';
// import ButtonPrint from '@components/Print/ButtonPrint';

// const Update = () => {
//   const [show, setShow] = useState(false);

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();
//   const { paymentId } = useParams();

//   const { Currency, loading: loading4 } = useLookupCurrency();
//   const { OperatingUnitOptions, loading: loading3, error: error7 } = useGetOperatingUnitWithPermission();
//   const { treeSuppliersData, error: error2, loading: loading2 } = useGetSuppliersList();
//   const { PaymentMethodList } = useGetPaymentMethod();
//   const { groupedOptions, loading: loading5, error: error5 } = useGetBankAccountsList();
//   const { PaymentTypeList  } = useGetPaymentTypeList();

//   useEffect(() => {
//     if (paymentId) {
//       dispatch(getApPaymentsById(paymentId));
//     }
//   }, [paymentId]);
//   const { ApPaymentsById: data, loadingById, errorById } = useAppSelector(a => a.ApPayments);

//   // تحديد إذا كان السند مرحلاً
//   const isPosted = data?.postedFlag === true;
//   const isCancelled = data?.status === 'cancelled'; // افترض أن هناك حقل cancelledFlag

//   //#region Formik
//   const formik = useFormik({
//     initialValues: {
//       prePaymentTotal: data.paymentType === paymentTypeEnum.PrePayment ? data.amount || 0 : 0, // ليس في البوست
//       //
//       paymentType: data.paymentType ?? '',
//       paymentDate: data.paymentDate?.split('T')[0] ?? '',
//       apBankAccountId: data.apBankAccountId ?? '',
//       paymentMethodId: data.paymentMethodId ?? '',
//       amount: data.amount ?? '',
//       currencyCode: data.currencyCode ?? '',
//       currencyConversionRate: data.currencyConversionRate ?? '',
//       peopleId: data.peopleId ?? '',
//       organizationId: data.organizationId ?? '',
//       creditMemoInvoiceId: data.creditMemoInvoiceId ?? '',
//       prePaymentId: data.prePaymentId ?? '',

//       description: data.description ?? '',

//       scheduleList:
//         data?.invoicePaymentList?.map(item => ({
//           // id: item.id,
//           // apPaymentScheduleId: item.apPaymentScheduleId,
//           // amount: item.amount,
//           id: item.id,
//           apPaymentScheduleId: item.apPaymentScheduleId,
//           invoiceNum: item.invoiceNum,
//           invoiceDate: item.invoiceDate?.toString()?.split('T')[0],
//           dueDate: item.dueDate?.toString()?.split('T')[0],
//           invoiceAmount: item.invoiceAmount,
//           schadualAmount: item.schadualAmount,
//           amount: item.amount,
//           actualRemainingAmount: item.schadualAmount // هنا يجب جلب المبلغ المتبقي لهذه الدفعة !! مازالت غير مهندلة
//         })) ?? []
//     },

//     enableReinitialize: true,
//     validationSchema: AddApPaymentsSchema(t),

//     onSubmit: async values => {
//       // // منع التعديل إذا كان مرحلاً
//       // if (isPosted) {
//       //   CustomAlert({ action: 'info', msg: t('لا يمكن تعديل السندات بعد الترحيل') });
//       //   formik.setSubmitting(false);
//       //   return;
//       // }
//       // const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد تعديل هذا السداد؟');
//       // if (!isConfirmation) {
//       //   formik.setSubmitting(false);
//       //   return;
//       // }
//       // const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);
//       // dispatch(
//       //   updateApPayments({
//       //     id: data.id,
//       //     apBankAccountId: values.apBankAccountId,
//       //     paymentMethodId: values.paymentMethodId,
//       //     paymentDate: values.paymentDate,
//       // description: values.description?.trim() || null,
//       //     amount: values.paymentType === paymentTypeEnum.PrePayment ? values.prePaymentTotal : totalAmount,
//       //     invoicePaymentList:
//       //       values.paymentType === paymentTypeEnum.PrePayment
//       //         ? []
//       //         : values.scheduleList.map(item => ({
//       //             id: item.id,
//       //             apPaymentScheduleId: item.apPaymentScheduleId,
//       //             amount: item.amount
//       //           }))
//       //   })
//       // )
//       //   .unwrap()
//       //   .then((res: any) => {
//       //     // debugger; غ
//       //     // console.log(res);
//       //     if (res?.succeeded === true) {
//       //       CustomAlert({ action: 'Edit' });
//       //       navigate('/Finance/Ap/ApPayments', { replace: true });
//       //     } else {
//       //       CustomAlert({ action: 'Error', msg: res?.message });
//       //     }
//       //   })
//       //   .catch((error: any) => {
//       //     CustomAlert({ action: 'Error' });
//       //   })
//       //   .finally(() => {
//       //     formik.setSubmitting(false);
//       //   });
//     }
//   });
//   const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
//   //#endregion

//   const [showCancelModal, setShowCancelModal] = useState(false);
//   // دالة إلغاء السند
//   const handleCancelPayment = async () => {
//     if (!paymentId) return;

//     // const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد إلغاء هذا السند؟');
//     // if (!isConfirmation) return;

//     dispatch(cancelApPayments({ paymentId: paymentId }))
//       .unwrap()
//       .then((res: any) => {
//         if (res?.succeeded === true) {
//           CustomAlert({ action: 'Add', msg: t('تم إلغاء السند بنجاح') });
//           setShowCancelModal(false);
//           navigate('/AP/ApPayments', { replace: true });
//         } else {
//           CustomAlert({ action: 'Error', msg: res?.message || t('فشل في إلغاء السند') });
//         }
//       })
//       .catch((error: any) => {
//         CustomAlert({ action: 'Error', msg: error || t('حدث خطأ أثناء إلغاء السند') });
//       });
//   };

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: 'سندات الدفع',
//               link: '/AP/ApPayments'
//             },
//             {
//               name: 'تفاصيــل سند الدفع',
//               link: null
//             }
//           ]}
//           PageName='تفاصيــل سند الدفع'
//         />
//         <div className='ms-auto'>
//           <div className='col-5 col-md-6 text-end'>
//             <ButtonPrint
//               PrintTemplateTypeId='C1F76345-5512-4673-8132-25D54D5815B2' // قوالب سندات الدفع
//               ReferenceId={data.id || ''}
//             />
//           </div>
//         </div>
//       </div>

//       <Card>
//         <Loading
//           loading={loading5 || loading2 || loading3 || loading4 || loadingById}
//           error={error2 || error5  || error7 || errorById}
//         >
//           {isPosted && (
//             <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
//               <div className='d-flex align-items-center'>
//                 <i className='fas fa-info-circle fa-2x me-3'></i>
//                 <div>
//                   <h5 className='mb-1'>{t('تم ترحيـل السند')}</h5>
//                   <p className='mb-0'>{t('لا يمكن تعديل السندات بعد الترحيل في النظام')}</p>
//                 </div>
//               </div>

//               {/* الزر في الطرف الآخر */}
//               <button type='button' className='btn btn-sm btn-info' onClick={() => setShow(true)}>
//                 <i className='fa fa-info-circle fa-fw me-1'></i>
//                 {t('عرض القيد')}
//               </button>
//             </div>
//           )}

//           {isCancelled && (
//             <div className='alert alert-warning d-flex align-items-center justify-content-between m-2'>
//               <div className='d-flex align-items-center'>
//                 <i className='fas fa-ban fa-2x me-3'></i>
//                 <div>
//                   <h5 className='mb-1'>{t('تم إلغاء السند')}</h5>
//                   <p className='mb-0'>{t('هذا السند تم إلغاؤه ولا يمكن تعديله')}</p>
//                 </div>
//               </div>
//               {/* <StatusBadge status='cancelled' /> */}
//             </div>
//           )}
//           <Form onSubmit={formik.handleSubmit}>
//             <CardBody>
//               <div className='row'>
//                 {/* نوع الدفع */}
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('نوع السند')}</label>
//                     <Form.Select
//                       disabled
//                       className='form-select'
//                       name='paymentType'
//                       onChange={formikhandleChange}
//                       value={values.paymentType || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {PaymentTypeList?.map((item, idx) => (
//                         <option key={idx} value={item.id}>
//                           {i18n.language === 'en' ? item.name : item.name2}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     <div className='text-danger small'>{touched.paymentType && formik.errors.paymentType}</div>
//                   </div>
//                 </div>
//                 {/* {t('المورد')} */}
//                 <div className='col-lg-3 '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('المورد')}</label>
//                     <TreeSelect
//                       disabled
//                       showSearch
//                       className='w-100'
//                       treeLine
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       allowClear
//                       treeDefaultExpandAll={false} // لا تقم بتوسيع كل العقد افتراضيًا
//                       // loadData={} // يتم تحميل البيانات عند الطلب
//                       // onSearch={} // تنفيذ البحث عند كتابة المستخدم
//                       value={values.peopleId}
//                       onChange={option => {
//                         formik.setFieldValue('peopleId', option === null ? null : option);
//                       }}
//                       treeData={treeSuppliersData}
//                       treeNodeFilterProp='title'
//                     />
//                     <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
//                   </div>
//                 </div>
//                 {/* ('الفرع') */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('OperatingUnit')}</label>

//                     <Select
//                       // isDisabled={isPosted || loading3}
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading3}
//                       isSearchable={true}
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//                       onChange={(option: any) => setFieldValue('organizationId', option === null ? null : option.value)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                     <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
//                   </div>
//                 </div>

//                 {/* التاريخ */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('التاريخ')}</label>
//                     <Form.Control
//                       // disabled={isPosted}
//                       disabled
//                       className='form-control text-center'
//                       type='date'
//                       name='paymentDate'
//                       onChange={formikhandleChange}
//                       value={values.paymentDate || ''}
//                       // isInvalid={!!(touched.paymentDate && errors.paymentDate)}
//                     />
//                     <div className='text-danger small'>{touched.paymentDate && errors.paymentDate}</div>
//                   </div>
//                 </div>

//                 {![paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.ApplyPrePayment].includes(values.paymentType) && (
//                   <>
//                     {/* طريقة الدفع */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('PaymentMethod')}</label>
//                         <Form.Select
//                           disabled={isPosted}
//                           className='form-select'
//                           name='paymentMethodId'
//                           onChange={formik.handleChange}
//                           value={formik.values.paymentMethodId || ''}
//                           // isInvalid={
//                           //   !!(formik.touched.paymentMethodId && formik.errors.paymentMethodId)
//                           // }
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {PaymentMethodList?.map((item: any, idx: number) => (
//                             <option key={++idx} value={item.id}>
//                               {i18n.language === 'en' ? item.name : item.name2}
//                             </option>
//                           ))}
//                         </Form.Select>
//                         <div className='text-danger small'>{touched.paymentMethodId && errors.paymentMethodId}</div>
//                       </div>
//                     </div>
//                     {/* apBankAccountId */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('البنك / الصندوق')}</label>

//                         <Select
//                           isDisabled={isPosted || loading5}
//                           classNamePrefix='react-select'
//                           isLoading={loading5}
//                           isSearchable={true}
//                           isClearable
//                           options={groupedOptions}
//                           // value={groupedOptions?.find(
//                           //   (f: any) => f?.value === formik.values.apBankAccountId
//                           // )}
//                           value={groupedOptions?.find((item: any) =>
//                             item?.options?.some((option: any) => option.value === formik.values.apBankAccountId)
//                           )}
//                           onChange={(option: any) =>
//                             setFieldValue('apBankAccountId', option === null ? null : option?.value)
//                           }
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger small'>{touched.apBankAccountId && errors.apBankAccountId}</div>
//                       </div>
//                     </div>
//                     {/* ('Currency') */}
//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'> {t('Currency')} </label>
//                         <Form.Select
//                           disabled
//                           className='form-select'
//                           name='currencyCode'
//                           onChange={formikhandleChange}
//                           value={values.currencyCode || ''}
//                           // isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                           {Currency &&
//                             Currency?.map((item: any, idx: number) => (
//                               <option key={++idx} value={item.currencyCode}>
//                                 {item.description}
//                               </option>
//                             ))}
//                         </Form.Select>
//                         <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
//                       </div>
//                     </div>
//                     {/* ('معدل العملة') */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('معدل العملة')}</label>
//                         <Form.Control
//                           disabled
//                           readOnly
//                           className='form-control  text-center'
//                           type='text'
//                           autoComplete='off'
//                           name='currencyConversionRate'
//                           value={values.currencyConversionRate}
//                         />
//                       </div>
//                     </div>

//                     {/* الوصف */}
//                     <div className='col-lg-12'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Description')}</label>
//                         <Form.Control
//                           as='textarea'
//                           rows={1}
//                           className='form-control'
//                           name='description'
//                           value={values.description || ''}
//                           onChange={formikhandleChange}
//                           onBlur={() => setFieldTouched('description', true)}
//                           disabled // لأن شاشة التفاصيل عندك أغلبها disabled
//                           placeholder={i18n.language === 'ar' ? 'الوصف...' : 'Description...'}
//                         />
//                         <div className='text-danger small'>{touched.description && (errors as any).description}</div>
//                       </div>
//                     </div>
//                   </>
//                 )}
//                 {values.paymentType === paymentTypeEnum.PrePayment && (
//                   <div className='col-lg-3'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('مبلغ الدفعة المقدمة')}</label>
//                       <Form.Control
//                         disabled={isPosted}
//                         className='form-control text-center fs-5 fw-bold text-theme'
//                         type='text'
//                         autoComplete='off'
//                         name='prePaymentTotal'
//                         onChange={formikhandleChange}
//                         value={values.prePaymentTotal || ''}
//                         onInput={e => {
//                           const input = e.target as HTMLInputElement;
//                           input.value = input.value.replace(/[^0-9]/g, '');
//                         }}
//                       />
//                       <div className='text-danger small'>{errors.amount}</div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </CardBody>
//             <CardFooter className='mt-0 p-0'>
//               <PaymentDetailsCard
//                 paymentType={values.paymentType}
//                 Id={
//                   values.paymentType === paymentTypeEnum.ApplyDebitMemo
//                     ? values.creditMemoInvoiceId
//                     : values.paymentType === paymentTypeEnum.ApplyPrePayment
//                       ? values.prePaymentId
//                       : null
//                 }
//                 scheduleCount={formik.values.scheduleList?.length || 0}
//               />

//               <hr className='my-4' />

//               <div hidden={values.paymentType === paymentTypeEnum.PrePayment}>
//                 <ApScheduleList formik={formik} />
//               </div>

//               <div className='col-12 text-center mt-2'>
//                 {false && (
//                   <button
//                     disabled={formik.isSubmitting || isPosted}
//                     type='submit'
//                     className='btn btn-lg me-1 btn-theme mb-1 rounded-2'
//                   >
//                     {formik.isSubmitting ? (
//                       <div className='spinner-border spinner-border-sm me-2'></div>
//                     ) : (
//                       <i className='fas fa-lg fa-fw me-2 fa-credit-card'></i>
//                     )}
//                     {t('Save')}
//                   </button>
//                 )}

//                 {!isCancelled && (
//                   <button
//                     type='button'
//                     className='btn btn-lg me-1 btn-danger mb-1 rounded-2'
//                     onClick={() => setShowCancelModal(true)}
//                     disabled={formik.isSubmitting}
//                   >
//                     <i className='fas fa-lg fa-fw me-2 fa-times-circle'></i>
//                     {t('إلغاء السند')}
//                   </button>
//                 )}

//                 <button
//                   type='button'
//                   className='btn btn-lg me-1 btn-default mb-1 rounded-2'
//                   onClick={() => navigate('/AP/ApPayments', { replace: true })}
//                 >
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </CardFooter>
//           </Form>
//         </Loading>
//       </Card>

//       <NeatixModal show={show} setShow={setShow} size='xl' title='تفاصيـل القيد' centered>
//         {paymentId && <JournalsByReference referenceId={paymentId} />}
//       </NeatixModal>

//       <NeatixModal show={showCancelModal} setShow={setShowCancelModal} size='md' centered showHeader={false}>
//         <div className='text-center'>
//           <i className='fas fa-exclamation-triangle fa-3x text-warning mb-3'></i>
//           <h4>{t('تأكيد إلغاء السند')}</h4>
//           <p className='mb-4'>{t('هل أنت متأكد من أنك تريد إلغاء هذا السند؟ لا يمكن التراجع عن هذا الإجراء.')}</p>

//           <div className='d-flex justify-content-center gap-3'>
//             <button type='button' className='btn btn-danger' onClick={handleCancelPayment}>
//               <i className='fas fa-check me-2'></i>
//               {t('نعم، إلغاء السند')}
//             </button>
//             <button type='button' className='btn btn-secondary' onClick={() => setShowCancelModal(false)}>
//               <i className='fas fa-times me-2'></i>
//               {t('تراجع')}
//             </button>
//           </div>
//         </div>
//       </NeatixModal>
//     </>
//   );
// };

// export default Update;

/* eslint-disable no-constant-binary-expression */
/* eslint-disable react-refresh/only-export-components */
import { useFormik } from 'formik';
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { TreeSelect } from 'antd';
import { Card } from '@components/card/card';
import { CardBody, Form, Badge, Row, Col } from 'react-bootstrap';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import confirmAction from '@components/Shared/Alert/confirmAction';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
import useGetPaymentTypeList from '@hooks/Finance/ApPayments/useGetPaymentTypeList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { updateApPayments, getApPaymentsById, cancelApPayments } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
import ApScheduleList from '../ApScheduleList';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '../../../Journals/JournalsByReference/JournalsByReference';
import { paymentTypeEnum } from '../paymentTypeEnum';
import PaymentDetailsCard from '../Add/PaymentDetailsCard';
import ButtonPrint from '@components/Print/ButtonPrint';

const Update = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { paymentId } = useParams();

  // الحالة
  const [showJournalModal, setShowJournalModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // البيانات المرجعية
  const { Currency, loading: loadingCurrency } = useLookupCurrency();
  const { OperatingUnitOptions, loading: loadingOperatingUnits } = useGetOperatingUnitWithPermission();
  const { treeSuppliersData, loading: loadingSuppliers } = useGetSuppliersList();
  const { PaymentMethodList } = useGetPaymentMethod();
  const { groupedOptions, OptionsBankAccounts, loading: loadingBankAccounts } = useGetBankAccountsList();
  const { PaymentTypeList } = useGetPaymentTypeList();

  // بيانات السند
  const { ApPaymentsById: data, loadingById, errorById } = useAppSelector(a => a.ApPayments);

  // Fetch data by ID
  useEffect(() => {
    if (paymentId) {
      dispatch(getApPaymentsById(paymentId));
    }
  }, [paymentId, dispatch]);

  // الحالات الخاصة
  const isPosted = data?.postedFlag === true;
  const isCancelled = data?.status === 'cancelled';
  const NotEditable = isPosted || isCancelled;
  const todayDate = useMemo(() => new Date().toISOString().split('T')[0], []);

  // Formik

  //#region Formik
  const formik = useFormik({
    initialValues: {
      tranferFees: data?.tranferFees ?? 0,
      tranferFees_VAT: data?.tranferFees_VAT ?? 0,
      //
      prePaymentTotal: data.paymentType === paymentTypeEnum.PrePayment ? data.amount || 0 : 0, // ليس في البوست
      refundPrePaymentTotal: data.paymentType === paymentTypeEnum.PrePaymentRefund ? data.amount || 0 : 0, // ليس في البوست
      //
      paymentType: data.paymentType ?? '',
      paymentDate: data.paymentDate?.split('T')[0] ?? '',
      apBankAccountId: data.apBankAccountId ?? '',
      paymentMethodId: data.paymentMethodId ?? '',
      amount: data.amount ?? '',
      currencyCode: data.currencyCode ?? '',
      currencyConversionRate: data.currencyConversionRate ?? '',
      peopleId: data.peopleId ?? '',
      organizationId: data.organizationId ?? '',
      creditMemoInvoiceId: data.creditMemoInvoiceId ?? '',
      prePaymentId: data.prePaymentId ?? '',

      description: data.description ?? '',

      scheduleList:
        data?.invoicePaymentList?.map(item => ({
          // id: item.id,
          // apPaymentScheduleId: item.apPaymentScheduleId,
          // amount: item.amount,
          id: item.id,
          apPaymentScheduleId: item.apPaymentScheduleId,
          invoiceNum: item.invoiceNum,
          invoiceDate: item.invoiceDate?.toString()?.split('T')[0],
          dueDate: item.dueDate?.toString()?.split('T')[0],
          invoiceAmount: item.invoiceAmount,
          schadualAmount: item.schadualAmount,
          amount: item.amount,
          actualRemainingAmount: item.schadualAmount // هنا يجب جلب المبلغ المتبقي لهذه الدفعة !! مازالت غير مهندلة
        })) ?? []
    },

    enableReinitialize: true,
    validationSchema: AddApPaymentsSchema(t),

    onSubmit: async values => {
      // // منع التعديل إذا كان مرحلاً /
      // if (isPosted) {
      //   CustomAlert({ action: 'info', msg: t('لا يمكن تعديل السندات بعد الترحيل') });
      //   formik.setSubmitting(false);
      //   return;
      // }
      // const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد تعديل هذا السداد؟');
      // if (!isConfirmation) {
      //   formik.setSubmitting(false);
      //   return;
      // }
      // const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);
      // dispatch(
      //   updateApPayments({
      //     id: data.id,
      //     apBankAccountId: values.apBankAccountId,
      //     paymentMethodId: values.paymentMethodId,
      //     paymentDate: values.paymentDate,
      // description: values.description?.trim() || null,
      //     amount: values.paymentType === paymentTypeEnum.PrePayment ? values.prePaymentTotal : totalAmount,
      //     invoicePaymentList:
      //       values.paymentType === paymentTypeEnum.PrePayment
      //         ? []
      //         : values.scheduleList.map(item => ({
      //             id: item.id,
      //             apPaymentScheduleId: item.apPaymentScheduleId,
      //             amount: item.amount
      //           }))
      //   })
      // )
      //   .unwrap()
      //   .then((res: any) => {
      //     // debugger; غ
      //     // console.log(res);
      //     if (res?.succeeded === true) {
      //       CustomAlert({ action: 'Edit' });
      //       navigate('/Finance/Ap/ApPayments', { replace: true });
      //     } else {
      //       CustomAlert({ action: 'Error', msg: res?.message });
      //     }
      //   })
      //   .catch((error: any) => {
      //     CustomAlert({ action: 'Error' });
      //   })
      //   .finally(() => {
      //     formik.setSubmitting(false);
      //   });
    }
  });
  const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
  //#endregion

  // const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;

  // دالة إلغاء السند
  const handleCancelPayment = async () => {
    if (!paymentId) return;

    const isConfirmation = await confirmAction(t('هل أنت متأكد من أنك تريد إلغاء هذا السند؟'));
    if (!isConfirmation) return;

    try {
      const res = await dispatch(cancelApPayments({ paymentId })).unwrap();
      if (res?.succeeded) {
        CustomAlert({ action: 'Add', msg: t('تم إلغاء السند بنجاح') });
        setShowCancelModal(false);
        navigate('/AP/ApPayments', { replace: true });
      } else {
        CustomAlert({ action: 'Error', msg: res?.message || t('فشل في إلغاء السند') });
      }
    } catch (error) {
      CustomAlert({ action: 'Error', msg: t('حدث خطأ أثناء إلغاء السند') });
    }
  };

  // دالة مساعدة لعرض رسائل الخطأ
  const renderError = (fieldName: string) => {
    const t = (touched as any)[fieldName];
    const e = (errors as any)[fieldName];
    return t && e ? <div className='text-danger small mt-1'>{e as string}</div> : null;
  };

  // إخفاء بعض الحقول بناءً على نوع الدفع
  const showPaymentFields = ![paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.ApplyPrePayment].includes(
    values.paymentType
  );
  // const showScheduleList = values.paymentType !== paymentTypeEnum.PrePayment;
  const showScheduleList = ![
    paymentTypeEnum.PrePayment,
    paymentTypeEnum.Refund,
    paymentTypeEnum.PrePaymentRefund // ← جديد
  ].includes(values.paymentType);

  const loadingAllData =
    loadingCurrency || loadingOperatingUnits || loadingSuppliers || loadingBankAccounts || loadingById;

  if (loadingAllData) return <Loading loading={true} />;

  return (
    <div className='pb-5'>
      {/* الرأس (Header) */}
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            { name: 'Home', link: ':moduleHome' },
            { name: t('سندات الدفع'), link: '/AP/ApPayments' },
            { name: t('تفاصيل سند الدفع'), link: null }
          ]}
          PageName={
            <div className='d-flex align-items-center'>
              {t('تفاصيل سند الدفع')}
              {values.paymentType && (
                <Badge bg={isCancelled ? 'danger' : isPosted ? 'success' : 'primary'} className='ms-3 fs-12px'>
                  {isCancelled ? t('ملغى') : isPosted ? t('مرحل') : t('مسودة')}
                </Badge>
              )}
            </div>
          }
        />
        <div className='ms-auto'>
          <ButtonPrint PrintTemplateTypeId='C1F76345-5512-4673-8132-25D54D5815B2' ReferenceId={data?.id || ''} />
        </div>
      </div>

      {/* النموذج الرئيسي */}
      <Form onSubmit={formik.handleSubmit}>
        <Card className='shadow-sm border-0 mb-4'>
          <CardBody>
            {/* تحذيرات الحالة */}
            {isPosted && (
              <div className='alert alert-info d-flex align-items-center justify-content-between mb-2 rounded-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-check-circle fa-2x me-3 text-info'></i>
                  <div>
                    <h6 className='mb-0 fw-bold'>{t('تم ترحيل السند')}</h6>
                    <small>{t('لا يمكن تعديل السندات بعد الترحيل في النظام')}</small>
                  </div>
                </div>
                <button type='button' className='btn btn-outline-info' onClick={() => setShowJournalModal(true)}>
                  <i className='fas fa-file-invoice me-2'></i>
                  {t('عرض القيد')}
                </button>
              </div>
            )}

            {isCancelled && (
              <div className='alert alert-warning d-flex align-items-center rounded-3'>
                <i className='fas fa-ban fa-2x me-3 text-warning'></i>
                <div>
                  <h6 className='mb-0 fw-bold'>{t('تم إلغاء السند')}</h6>
                  <small>{t('هذا السند تم إلغاؤه ولا يمكن تعديله')}</small>
                </div>
              </div>
            )}

            <Row>
              {/* نوع الدفع */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('نوع السند')} <span className='text-danger'>*</span>
                  </label>
                  <Form.Select disabled name='paymentType' onChange={handleChange} value={values.paymentType}>
                    <option value=''>{t('اختر...')}</option>
                    {PaymentTypeList?.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {i18n.language === 'en' ? item.name : item.name2}
                      </option>
                    ))}
                  </Form.Select>
                  {renderError('paymentType')}
                </div>
              </Col>

              {/* المورد */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('المورد')} <span className='text-danger'>*</span>
                  </label>
                  <TreeSelect
                    disabled
                    showSearch
                    className='w-100'
                    treeLine
                    placeholder={t('اختر المورد...')}
                    allowClear
                    treeDefaultExpandAll={false}
                    value={values.peopleId}
                    onChange={option => setFieldValue('peopleId', option === null ? null : option)}
                    treeData={treeSuppliersData}
                    treeNodeFilterProp='title'
                  />
                  {renderError('peopleId')}
                </div>
              </Col>

              {/* الوحدة التشغيلية */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('الوحدة التشغيلية')} <span className='text-danger'>*</span>
                  </label>
                  <Select
                    classNamePrefix='react-select'
                    isDisabled
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId)}
                    onChange={(option: any) => setFieldValue('organizationId', option?.value || '')}
                    placeholder={t('اختر...')}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                  {renderError('organizationId')}
                </div>
              </Col>

              {/* التاريخ */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('التاريخ')} <span className='text-danger'>*</span>
                  </label>
                  <Form.Control
                    disabled={NotEditable}
                    type='date'
                    name='paymentDate'
                    onChange={handleChange}
                    value={values.paymentDate}
                  />
                  {renderError('paymentDate')}
                </div>
              </Col>

              {/* الحقول المشروطة */}
              {showPaymentFields && (
                <>
                  {/* طريقة الدفع */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('طريقة الدفع')}</label>
                      <Form.Select
                        disabled={NotEditable}
                        name='paymentMethodId'
                        onChange={handleChange}
                        value={values.paymentMethodId}
                      >
                        <option value=''>{t('اختر...')}</option>
                        {PaymentMethodList?.map((item: any, idx: number) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'en' ? item.name : item.name2}
                          </option>
                        ))}
                      </Form.Select>
                      {renderError('paymentMethodId')}
                    </div>
                  </Col>

                  {/* البنك / الصندوق */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('البنك / الصندوق')}</label>
                      <Select
                        classNamePrefix='react-select'
                        isDisabled={NotEditable}
                        isSearchable={true}
                        isClearable
                        options={groupedOptions}
                        value={OptionsBankAccounts?.find((f: any) => f?.value === values.apBankAccountId)}
                        onChange={(option: any) => setFieldValue('apBankAccountId', option?.value || null)}
                        placeholder={t('اختر...')}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                      {renderError('apBankAccountId')}
                    </div>
                  </Col>

                  {/* العملة */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('العملة')}</label>
                      <Form.Select disabled name='currencyCode' onChange={handleChange} value={values.currencyCode}>
                        <option value=''>{t('اختر...')}</option>
                        {Currency?.map((item: any, idx: number) => (
                          <option key={++idx} value={item.currencyCode}>
                            {item.description}
                          </option>
                        ))}
                      </Form.Select>
                      {renderError('currencyCode')}
                    </div>
                  </Col>

                  {/* سعر الصرف */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('سعر الصرف')}</label>
                      <Form.Control
                        disabled
                        readOnly
                        type='text'
                        name='currencyConversionRate'
                        value={values.currencyConversionRate}
                        className='text-center'
                      />
                    </div>
                  </Col>

                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('رسوم التحويل')}</label>
                      <Form.Control
                        disabled={NotEditable}
                        type='text'
                        name='tranferFees'
                        value={values.tranferFees}
                        // onChange={handleChange}
                        // onInput={(e: any) => {
                        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        // }}
                        placeholder='0'
                        className='text-center'
                      />
                      {renderError('tranferFees')}
                    </div>
                  </Col>

                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>
                        {t('ضريبة القيمة المضافة على الرسوم')}
                      </label>
                      <Form.Control
                        disabled={NotEditable}
                        type='text'
                        name='tranferFees_VAT'
                        value={values.tranferFees_VAT}
                        // onChange={handleChange}
                        // onInput={(e: any) => {
                        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        // }}
                        placeholder='0'
                        className='text-center'
                      />
                      {renderError('tranferFees_VAT')}
                    </div>
                  </Col>

                  {/* الوصف */}
                  <Col lg={12}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('الوصف')}</label>
                      <Form.Control
                        as='textarea'
                        rows={1}
                        disabled={NotEditable}
                        name='description'
                        value={values.description}
                        onChange={handleChange}
                        onBlur={() => setFieldTouched('description', true)}
                        placeholder={t('اكتب وصفاً مختصراً للسداد...')}
                      />
                      {renderError('description')}
                    </div>
                  </Col>
                </>
              )}

              {/* مبلغ الدفعة المقدمة */}
              {/* {values.paymentType === paymentTypeEnum.PrePayment && ( */}
              {[paymentTypeEnum.PrePayment, paymentTypeEnum.PrePaymentRefund].includes(values.paymentType) && (
                <Col lg={3} md={6}>
                  <div className='form-group mb-3'>
                    {/* <label className='form-label small fw-bold text-muted'>
                      {t('مبلغ الدفعة المقدمة')} <span className='text-danger'>*</span>
                    </label> */}
                    <label className='form-label small fw-bold text-muted'>
                      {values.paymentType === paymentTypeEnum.PrePaymentRefund
                        ? t('مبلغ الاسترداد')
                        : t('مبلغ الدفعة المقدمة')}{' '}
                      <span className='text-danger'>*</span>
                    </label>
                    <Form.Control
                      disabled={NotEditable}
                      className='text-center fs-5 fw-bold text-theme'
                      type='text'
                      name='prePaymentTotal'
                      onChange={handleChange}
                      value={
                        values.paymentType === paymentTypeEnum.PrePaymentRefund
                          ? values.refundPrePaymentTotal
                          : values.prePaymentTotal
                      }
                      onInput={e => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value.replace(/[^0-9]/g, '');
                      }}
                    />
                    {renderError('prePaymentTotal')}
                  </div>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>

        {/* تفاصيل الدفع */}
        {/* <PaymentDetailsCard
          paymentType={values.paymentType}
          Id={
            values.paymentType === paymentTypeEnum.ApplyDebitMemo
              ? values.creditMemoInvoiceId
              : values.paymentType === paymentTypeEnum.ApplyPrePayment
                ? values.prePaymentId
                : null
          }
          scheduleCount={values.scheduleList?.length || 0}
        /> */}

        <PaymentDetailsCard
          paymentType={values.paymentType}
          Id={
            [paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(values.paymentType)
              ? values.creditMemoInvoiceId
              : [paymentTypeEnum.ApplyPrePayment, paymentTypeEnum.PrePaymentRefund].includes(values.paymentType) // ← تعديل
                ? values.prePaymentId
                : null
          }
          scheduleCount={values.scheduleList?.length || 0}
        />

        {/* جدول السداد */}
        {showScheduleList && (
          <Card className='shadow-sm border-0 mb-4'>
            {/* <ApScheduleList formik={formik} NotEditable={NotEditable} /> */}
            <ApScheduleList formik={formik} />
          </Card>
        )}

        {/* أزرار الأكشن */}
        <Card className='mt-3 p-3 shadow'>
          <div className='d-flex justify-content-center gap-3'>
            <button
              type='button'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
              className='btn btn-outline-secondary px-4'
            >
              <i className='fas fa-times me-2'></i> {t('إلغاء')}
            </button>

            {/* {!isCancelled && !isPosted && (
              <button
                type='submit'
                disabled={isSubmitting || NotEditable}
                className='btn btn-theme px-5 fw-bold shadow'
              >
                {isSubmitting ? (
                  <span className='spinner-border spinner-border-sm me-2'></span>
                ) : (
                  <i className='fas fa-save me-2'></i>
                )}
                {t('حفظ التعديلات')}
              </button>
            )} */}

            {!isCancelled && (
              <button
                type='button'
                className='btn btn-danger px-5'
                onClick={() => setShowCancelModal(true)}
                disabled={isPosted}
              >
                <i className='fas fa-ban me-2'></i>
                {t('إلغاء السند')}
              </button>
            )}
          </div>
        </Card>
      </Form>

      {/* Modal لعرض القيد */}
      <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' title={t('تفاصيل القيد')} centered>
        {paymentId && <JournalsByReference referenceId={paymentId} />}
      </NeatixModal>

      {/* Modal تأكيد الإلغاء */}
      <NeatixModal show={showCancelModal} setShow={setShowCancelModal} size='md' centered showHeader={false}>
        <div className='text-center p-4'>
          <i className='fas fa-exclamation-triangle fa-3x text-warning mb-3'></i>
          <h5 className='fw-bold mb-3'>{t('تأكيد إلغاء السند')}</h5>
          <p className='text-muted mb-4'>
            {t('هل أنت متأكد من أنك تريد إلغاء هذا السند؟ لا يمكن التراجع عن هذا الإجراء.')}
          </p>

          <div className='d-flex justify-content-center gap-3'>
            <button type='button' className='btn btn-danger px-4' onClick={handleCancelPayment} disabled={isSubmitting}>
              {isSubmitting ? (
                <span className='spinner-border spinner-border-sm me-2'></span>
              ) : (
                <i className='fas fa-check me-2'></i>
              )}
              {t('نعم، إلغاء السند')}
            </button>
            <button type='button' className='btn btn-outline-secondary px-4' onClick={() => setShowCancelModal(false)}>
              <i className='fas fa-times me-2'></i>
              {t('تراجع')}
            </button>
          </div>
        </div>
      </NeatixModal>
    </div>
  );
};

export default Update;
